import { cn } from 'shared/styles'
import { Decade } from './types/Decade'

type Props<T extends Date | Decade> = {
  headerText: string
  elements: T[]
  makeElementText: (element: T) => string
  onHeaderClick?: () => void
  onElementClick: (newSelected: T) => void
  isSelectedElement: (element: T) => boolean
  disabledDates?: (element: T) => boolean
}

export function ElementPicker<F extends Date | Decade = Date>({
  headerText,
  elements,
  disabledDates,
  makeElementText,
  onHeaderClick,
  onElementClick,
  isSelectedElement,
}: Props<F>) {
  return (
    <>
      <button
        onClick={onHeaderClick}
        className='text-center transition hover:text-blue-500'
      >
        {headerText}
      </button>

      <div className='border-t-2 border-gray-400' />

      <ul className='grid grid-cols-3'>
        {elements.map((element, idx) => (
          <li key={idx}>
            <button
              onClick={() => onElementClick(element)}
              type='button'
              className={cn(
                'flex size-full items-center justify-center rounded-md py-1 transition hover:bg-blue-500 hover:text-white disabled:bg-transparent disabled:text-gray-400',
                isSelectedElement(element) && 'bg-blue-500 text-white',
              )}
              disabled={disabledDates && disabledDates(element)}
            >
              {makeElementText(element)}
            </button>
          </li>
        ))}
      </ul>
    </>
  )
}
